export default __webpack_public_path__ + "static/media/arrow-left.f535dd56.svg";